<!-- Upload File Section -->
<div class="widget-container">
  <ion-grid>
    <ion-row class="close-row">
      <ion-col (click)="close()" class="close-col">
        <img tooltip="{{'Close' | translate }}" placement="bottom" alt="" src="assets/icon/cancel.svg">
      </ion-col>
    </ion-row>

    <!-- Machine Library Upload -->
    <div *ngIf="type === 'Machine Library'">
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            {{ 'Bulk Upload' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <p class="libraryTitle">
          <span>{{'Please'}}</span>
          <span>
            <a download href="javascript: void(0);" (click)='downloadBulkUploadMachineTemplate()'>
              {{' Download '|translate}}</a>
          </span>
          <span>{{'the template and fill the data'}}</span>
        </p>
      </ion-row>
      <div>
        <ion-row style="height: 5px;"></ion-row>
        <div class="upload-container">

          <div class="center">
            <input type="file" value="" title="" accept=".xls,.xlsx,.csv" class="custom-file-input"
              (change)="onUploadChange($event)" multiple="false" [(ngModel)]="isShowButton">
          </div>
        </div>
      </div>
    </div>

    <!-- Roadmap Documents Upload -->
    <div *ngIf="type === 'Roadmaps'">
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            {{ 'Upload Roadmap Library Documents' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row style="padding-top: 2em;">
        <label class="c-stepper__title"> {{ 'Please Download Template' | translate }}</label>
      </ion-row>
      <ion-row>

        <p class="libraryTitle">
          {{'Roadmap library requires a specific format,Please download the template and fill the data'|translate}}</p>
      </ion-row>
      <ion-row>
        <a class="sheetTitle" tabindex="0" role="button"
          (click)="downloadRoadmapTemplate()"
          (keydown.enter)="downloadRoadmapTemplate()">
          {{'Download Template'|translate}}</a>
      </ion-row>
      <ion-row class=" space">
      </ion-row>
      <div>
        <div style="margin-left:1em">
          <label class="uploadTitle"> {{ 'Add Roadmap Library Files Only' | translate }}</label>
        </div>
        <ion-row style="height: 5px;"></ion-row>
        <div class="upload-container">
          <div class="upload-file-roadmap">
            <input type="file" value="" title="" accept=".xls,.xlsx,.csv" class="custom-file-input"
              (change)="onRoadMapUpload($event)" multiple="false" [(ngModel)]="isShowButton" />
          </div>
        </div>
      </div>
    </div>

    <!-- Measure Documents Upload -->
    <div *ngIf="type === HazardMeasureConstants.MEASURES">
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            {{ 'Upload Measures Documents' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row style="padding-top: 2em;">
        <label class="c-stepper__title">{{ 'Please Download Template' | translate }}</label>
      </ion-row>
      <ion-row>
        <p class="libraryTitle">{{'Measures are required in a specific format Please download the template and fill the data.' | translate }}</p>
      </ion-row>
      <ion-row>
        <a class="sheetTitle" download href="javascript: void(0);" (click)='downloadMeasureTemplate()'>
          {{' Download '|translate}}
        </a>
      </ion-row>
      <div>
        <div class="upload-container">
          <div class="center">
            <input type="file" value="" title="" accept=".xls,.xlsx,.csv" class="custom-file-input"
              (change)="onUploadMeasure($event)" multiple="false" [(ngModel)]="isShowButton" />
          </div>
        </div>
      </div>
    </div>

    <!-- Initial Hazard Documents Upload -->
    <div *ngIf="type === 'Initial Hazards'">
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            {{ 'Upload Initial Hazards Documents' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row style="padding-top: 2em;">
        <label class="c-stepper__title">{{ 'Please Download Template' | translate }}</label>
      </ion-row>
      <ion-row>
        <p class="libraryTitle">{{ 'Initial Hazards are required in a specific format Please download the template and fill the data.' | translate }}</p>
      </ion-row>
      <ion-row>
        <a class="sheetTitle" download href="javascript: void(0);" (click)='downloadInitialHazardTemplate()'>
          {{' Download '|translate}}
        </a>
      </ion-row>
      <div>
        <ion-row style="height: 5px;"></ion-row>
        <div class="upload-container">
          <div class="center">
            <input type="file" value="" title="" accept=".xls,.xlsx,.csv" class="custom-file-input"
              (change)="onUploadInitialHazard($event);" multiple="false" [(ngModel)]="isShowButton" />
          </div>
        </div>
      </div>
    </div>

    <!-- Upload Functionality for Remain Libraries -->
    <div
      *ngIf="type !== ('Roadmaps' | translate) 
    && type !== ('User Roadmaps' | translate) 
    && type !== ('Measures' | translate) 
    && type !== ('Initial Hazards' | translate) 
    && type !== ('Risk Assessment Report Template' | translate) 
    && type !== ('Quote Templates' | translate) 
    && type !== ('Machine Library' | translate)">
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            {{ 'Upload Documents' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <p class="libraryTitle">
          {{'Please Upload this template in specific format Supported File Format:pdf'|translate}}
        </p>
      </ion-row>
      <ion-row style="height: 5px;"></ion-row>
      <div class="upload-container">

        <div class="upload-file">
          <input type="file" value="" title="" accept=".pdf" (change)="uploadValid($event)" class=" custom-file-input"
            multiple="false" [(ngModel)]="isShowButton" />
        </div>
      </div>
    </div>
    <div
      *ngIf="type !== ('Risk Assessment Static Report Templates' | translate)
    && type !== ('Roadmaps' | translate)
    && type !== ('User Roadmaps' | translate)
    && type !== ('Measures' | translate) 
    && type !== ('Initial Hazards' | translate)
    && type !== ('Standard Documents' | translate) 
    && type !== ('Legislation Documents' | translate)
    && type !== 'Machine Library'">
      <ion-row class="header-row">
        <ion-col>
          <div class="ion-text-start header-title">
            {{ 'Upload Documents' | translate }}
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <p class="libraryTitle">
          {{'Please Upload this template in specific format Supported File Format :.docx'|translate}}{{type}}
        </p>
      </ion-row>
      <ion-row style="height: 5px;"></ion-row>
      <div class="upload-container">
        <div class="upload-file">
          <input type="file" value="" (change)="uploadValidDoc($event)" title="" accept=".docx"
            class="custom-file-input" multiple="false" [(ngModel)]="isShowButton" />
        </div>
      </div>
    </div>

    <ion-row class="button-row">
      <ion-button *ngIf="type === 'Machine Library'" class="app-btn" shape="round" fill="outline" color="primary"
        [disabled]="!isButtonEnable" (click)="bulkUploadMachine()">
        {{'Done'|translate}}
      </ion-button>
    </ion-row>
    <ion-row class="button-row">
      <ion-button *ngIf="type === 'Roadmaps'" class="app-btn" shape="round" fill="outline" color="primary"
        [disabled]="!isButtonEnable" (click)="dismissRoadMapModal()">
        {{'Done'|translate}}
      </ion-button>
    </ion-row>
    <ion-row class="button-row">
      <ion-button *ngIf="type === 'Initial Hazards'" class="app-btn" shape="round" fill="outline" color="primary"
        [disabled]="!isButtonEnable" (click)="dismissInitialHazard()">
        {{'Done'|translate}}
      </ion-button>
    </ion-row>
    <ion-row class="button-row">
      <ion-button *ngIf="type === HazardMeasureConstants.MEASURES" class="app-btn" shape="round" fill="outline" color="primary"
        [disabled]="!isButtonEnable" (click)="dismissMeasure()">
        {{'Done'|translate}}
      </ion-button>
    </ion-row>
    <ion-row class="button-row">
      <ion-button
        *ngIf="type === 'Standard Documents' || type === 'Legislation Documents' || type === 'Quote Templates' || type === 'Risk Assessment Static Report Templates' "
        class="app-btn" shape="round" fill="outline" color="primary" [disabled]="!isButtonEnable"
        (click)="dismissUploadModal()">
        {{'Done'|translate}}
      </ion-button>
    </ion-row>
  </ion-grid>
</div>